import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const FreeWallpaperFriday = ({ onAddToBasket }) => {
  const [wallpapers, setWallpapers] = useState([]);
  const serverUrl = process.env.REACT_APP_API_BASE_URL || '';
  const imageBaseUrl = `${serverUrl}/generated-wallpapers`;

  useEffect(() => {
    const maxWallpapers = 10;

    const checkImages = async () => {
      const available = [];

      for (let i = 1; i <= maxWallpapers; i++) {
        const fileName = `free-friday${i}.jpg`;
        try {
          const response = await fetch(`${imageBaseUrl}/${fileName}`, { method: 'HEAD' });
          if (response.ok) {
            available.push(fileName);
          }
        } catch (err) {
          // Ignore missing files
        }
      }

      setWallpapers(available);
    };

    checkImages();
  }, []);

const handleAddToBasket = (fileName) => {
  onAddToBasket({
    description: `Free Friday Wallpaper - ${fileName}`,
    url: `/generated-wallpapers/${fileName}`,
    price: 0.00,
    includePhoneCase: true,
    phoneCaseBrand: 'Generic',
    phoneCaseModel: 'Select Model',
    phoneCaseFinish: 'Gloss',
    color: 'default'
  });
};

  return (
    <div className="free-wallpaper-friday">
      <div className="top-nav">
        <Link to="/" className="home-link">← Home</Link>
      </div>

      <h1>🎁 Free Wallpaper Friday</h1>
      <p>Download this week's free wallpaper — or (coming soon) turn one into a real phone case to match! Keep an eye on our Instagram for more!</p>

      <div className="wallpaper-grid">
        {wallpapers.map((file, index) => (
          <div className="wallpaper-card" key={index}>
            <img
              src={`${imageBaseUrl}/${file}`}
              alt={`Free Wallpaper ${index + 1}`}
              className="wallpaper-thumbnail"
            />
            <div className="button-group">
              <a
                href={`${imageBaseUrl}/${file}`}
                download
                className="download-btn"
              >
                ⬇ Download
              </a>
            </div>
          </div>
        ))}
      </div>

      <div className="custom-cta">
        <h3>✨ Want something exclusive?</h3>
        <p>Create your own one-of-a-kind wallpaper and matching phone case!</p>
	  <Link to="/" className="create-btn">Design Yours Now</Link>
      </div>
    </div>
  );
};

export default FreeWallpaperFriday;

